
const constants = {
  SecretPrefix: 'secret_',

  changelogLink: 'https://kaydotai.notion.site/Changelog-1912183756c4808eabacd27b7077dfe1?pvs=4',

  clientType: 'subscriber',

  editorKey: 'EDITOR',
  interactDemoPrefix: 'demo',

  interactTaskPrefix: 'task-',

  kayLogoUrl: 'https://cdn.prod.website-files.com/64ea0831400c941a3ba96e05/64ea2e977e148519763205e7_logo-test.png',

  lastUserId: 'lastUserId',
  localFlag: 'local',

  plainAppId: 'liveChatApp_01KZVM4QEEPWVS3CP8FCE2ZMEX',

  sampleKey: 'SAMPLE_KEY',

  slackDefaultAnswerHook: 'https://hooks.slack.com/triggers/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',

  workflowIdPrefKey: 'workflowIdPref',
};

export default constants;
